export default __webpack_public_path__ + "static/media/twitter_light_purple.59ffafbf.svg";